import _ from 'underscore';
import { lAsync } from 'app/blocks/common/codes';
import emitter from 'app/blocks/common/events/emitter';
import Events from 'app/blocks/common/events/Events';
import showDialog from 'app/blocks/common/jsx/dialogModal';
import Alerts from 'app/blocks/common/spinner';
import { logout } from 'app/blocks/middleware/authentication';
import * as middleware from 'app/blocks/middleware/middleware';
import * as MiddlewareOrcid from 'app/blocks/middleware/orcid';
import { confirm } from 'app/blocks/Modal/utils';
import {
    confirmAffiliationImport,
    confirmLogin,
    notifyUserThatThereAreNoOrcidAffiliations,
} from 'app/blocks/orcid/utils';
import { updateOrcid } from 'app/pages/profile/profile-information/utils';
import OrcidConnector from './OrcidConnector';

async function spinner(fn) {
    try {
        Alerts.renderSpinner();

        return typeof fn === 'function' ? await fn() : await fn;
    } finally {
        Alerts.removeSpinner();
    }
}

const importAffiliationsFromOrcid = async orcidCode => {
    try {
        await spinner(MiddlewareOrcid.importAffiliations(orcidCode));
        emitter.emit(Events.AFFILIATIONS_UPDATED);
    } catch (error) {
        if (error.code === 'PROFILE_UPDATE_ORCID_ID_CONFLICT') {
            if (await confirmLogin(error.payload)) {
                logout();
            }
        } else {
            showDialog.error(error);
        }
    }
};

async function showDialogForAffiliationsImport(affiliations, orcidCode) {
    try {
        await spinner(updateOrcid(orcidCode));
    } catch (error) {
        showDialog.error(error);
    }

    if (_.isEmpty(affiliations)) {
        notifyUserThatThereAreNoOrcidAffiliations();
    } else if (await confirmAffiliationImport(affiliations)) {
        importAffiliationsFromOrcid(orcidCode);
    }
}

async function checkLinkOrcidNeeded() {
    const profileInfo = await spinner(middleware.profile.getProfileInfo());

    if (!profileInfo || !profileInfo.orcidId) {
        return confirm(await lAsync('PROFILE_ACCOUNT.confirmationMessages.PROFILE_ACCNT_ORCID_LINK_REQUIRED'));
    }

    return true;
}

const importFromOrcid = async () => {
    try {
        if (await checkLinkOrcidNeeded()) {
            Alerts.renderSpinner();
            const [orcidCode] = await new OrcidConnector().connect();
            const affiliations = await MiddlewareOrcid.getAffiliations(orcidCode);
            Alerts.removeSpinner();
            showDialogForAffiliationsImport(affiliations, orcidCode);
        }
    } catch (error) {
        showDialog.error(error);
    } finally {
        Alerts.removeSpinner();
    }
};

function importAffiliations(orcidCode, affiliations) {
    if (!_.isEmpty(affiliations)) {
        showDialogForAffiliationsImport(affiliations, orcidCode);
    }
}

export { importAffiliations };
export default importFromOrcid;
